import { NgModule } from '@angular/core';
import { ModalComponent } from '@app/shared/components/modal-layout/modal.component';
import { ModalBodyComponent } from '@app/shared/components/modal-layout/modal-body.component';
import { ModalFooterComponent } from '@app/shared/components/modal-layout/modal-footer.component';
import { ModalHeaderComponent } from '@app/shared/components/modal-layout/modal-header.component';

@NgModule({
  imports: [
  ],
  declarations: [
    ModalComponent,
    ModalBodyComponent,
    ModalHeaderComponent,
    ModalFooterComponent
  ],
  exports: [
    ModalComponent,
    ModalBodyComponent,
    ModalHeaderComponent,
    ModalFooterComponent
  ]
})
export class ModalLayoutModule {

}
